import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
const ArthaContinueButton = styled(Button)(({ theme }) => ({
  background: "rgb(255, 115, 0)",
  color: "white",
  boxShadow: "none",
  minWidth: "80px",
  width: "auto",
  maxWidth: "100%",
  height: "30px",
  padding: "6px 16px",
  textTransform: "capitalize",
  borderRadius: "40px",
  margin: "0px 3px",
  fontWeight: "700",
  fontSize: "12px",
  whiteSpace: "nowrap",
  "&:hover": {
    background: "#FF8000",
    boxShadow: "none"
  },
  ":disabled": {
    backgroundColor: "rgb(255 98 0 / 39%)",
  },
  // Mobile responsive
  "@media (max-width: 576px)": {
    minWidth: "70px",
    height: "28px",
    fontSize: "11px",
    padding: "4px 12px",
    margin: "0px 2px",
  },
  // Tablet responsive
  "@media (min-width: 577px) and (max-width: 991px)": {
    minWidth: "80px",
    height: "30px",
    fontSize: "11px",
    padding: "5px 14px",
  },
}));

export default ArthaContinueButton;
